import uniqBy from 'lodash-es/uniqBy'

import { BirdviewAttentionEntity } from '../../DashboardBirdview.constants.attention'
import {
  toBirdviewActivityItem,
  toBirdviewWidgetRequestItem,
} from '../../DashboardBirdview.utils.api'

import {
  BIRDVIEW_ATTENTION_GROUP_LABEL_KEY,
  BIRDVIEW_ATTENTION_OPEN_GROUP_INDEX,
} from './useBirdviewAttentionLoaders.constants'

function checkIsBirdviewAttentionActivityRow(row) {
  return row.entity === BirdviewAttentionEntity.Activity
}

function checkIsBirdviewAttentionGroupShown({ count, reason }) {
  return count > 0 && Object.hasOwn(BIRDVIEW_ATTENTION_GROUP_LABEL_KEY, reason)
}

function checkIsBirdviewAttentionGroupOpenByDefault(index) {
  return index === BIRDVIEW_ATTENTION_OPEN_GROUP_INDEX
}

function toBirdviewAttentionRowItem(row) {
  return {
    ...(checkIsBirdviewAttentionActivityRow(row)
      ? toBirdviewActivityItem(row)
      : toBirdviewWidgetRequestItem(row)),
    entity: row.entity,
  }
}

// One request can sit in several groups, so the tags are asked for once per id.
export function getBirdviewAttentionRequestRows(groups) {
  return uniqBy(
    groups
      .flatMap(group => group.items)
      .filter(row => !checkIsBirdviewAttentionActivityRow(row)),
    'id'
  )
}

export function toBirdviewAttentionSection({ data, extra }) {
  return {
    extra,
    items: data.items
      .filter(checkIsBirdviewAttentionGroupShown)
      .map((group, index) => ({
        count: group.count,
        id: group.reason,
        isOpenByDefault: checkIsBirdviewAttentionGroupOpenByDefault(index),
        items: group.items.map(toBirdviewAttentionRowItem),
        labelKey: BIRDVIEW_ATTENTION_GROUP_LABEL_KEY[group.reason],
        tone: group.tone,
      })),
    total: data.total,
  }
}
